export class Obligation {
    id: number;
    obligation: string;
    counterPartyId: number;
    counterPartyName: string;
    date: Date;
    agreementId: number;
    counterPartyCountry: string;
    transactionRule: TransactionRule;
}

export class TransactionRule {
    id: number;
    accountNo: string;
    name: string;
    txnDescription: string;
    cashFlow: number;
    amountFrom: number;
    amountTo: number;
    maxAmount: number;
    maxAmountPeriod: number;
    maxAmountPeriodName: string;
    maxAmountPeriodFrom: Date;
    maxAmountPeriodTo: Date;
    frequency: number;
    frequencyPeriod: number;
    frequencyPeriodName: string;
    frequencyPeriodFrom: Date;
    frequencyPeriodTo: Date;
    counterPartyId: number;
    counterPartyName: string;
    counterPartyAccountNumber: string;
    counterPartyAccounts: Array<string>;
    originCountry: number;
    cashFlowName: string;
    originCountryName: string;
    reviewStatus: ReviewStatus;
}

enum ReviewStatus {
    DRAFT, FINAL, REVIEW
}



// WEBPACK FOOTER //
// ./src/app/entities/transaction-profile/obligation.model.ts